<template>
  <div>
    <popup-edit-tax-group ref="popupEditTaxGroup" />
    <div class="flex justify-between p-3">
      <p>
        Tax rates are sales tax rates that can be applied to products. This is
        constant for Denmark but varying for other countries.
      </p>
      <div class="flex justify-end">
        <vs-button
          icon="add"
          @click="$refs.popupEditTaxGroup.show()"
          type="relief"
          color="primary"
          class="mr-3"
          >Add tax rate</vs-button
        >
      </div>
    </div>
    <vs-row class="mt-4">
      <vs-col
        class="rolecard p-3"
        v-for="pc in taxGroups"
        :key="pc.taxGroupId.id"
      >
        <vs-card>
          <div slot="header">
            <vs-row vs-justify="space-between">
              <h6>{{ pc.code }}</h6>
              <div>
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click="$refs.popupEditTaxGroup.show(pc)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  @click="confirmDelete(pc)"
                />
              </div>
            </vs-row>
          </div>
          <div>
            <vs-row class="mt-4">
              <vs-col vs-w="4">Code</vs-col>
              <vs-col vs-w="8"
                ><i>{{ pc.code }}</i></vs-col
              >
            </vs-row>
            <vs-row class="mt-4">
              <vs-col vs-w="4">Rate</vs-col>
              <vs-col vs-w="8"
                ><i>{{ pc.taxRatePercentage }}%</i></vs-col
              >
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>

    <!-- Save & Remove Button -->
    <vs-row>
      <vs-button id="save-button" @click="saveChanges" class="mt-2"
        >Save Changes</vs-button
      >
    </vs-row>
  </div>
</template>

<script>
import popupEditTaxGroup from "./PopupEditTaxGroup";
import { mapGetters } from "vuex";
export default {
  components: {
    popupEditTaxGroup,
  },
  data() {
    return {
      removeId: "",
    };
  },
  methods: {
    async confirmDelete(tr) {
      this.removeId = tr.taxGroupId.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this tax group?",
        accept: this.remove,
      });
    },
    async saveChanges() {
      this.$vs.loading();
      await this.$store.dispatch("pos/countrySettings/updateCountrySettings");
      this.$vs.loading.close();
    },
    async remove() {
      this.$store.commit("pos/countrySettings/deleteTaxGroup", this.removeId);
    },
  },
  computed: {
    ...mapGetters({
      taxGroups: "pos/countrySettings/taxGroups",
    }),
  },

  async mounted() {},
};
</script>


<style lang="scss" scoped>
.role-table {
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.rolecard {
  &.deactivated {
    opacity: 0.75;
  }

  min-width: 380px;
  max-width: 380px;

  .con-vs-card {
    border: 2px solid #ccc;
  }

  .vs-card--content {
    margin-bottom: 0;
  }

  .vs-card--footer {
    padding: 6px 12px;
    margin-top: 0;
    transform: none;
    background-color: #ccc;
    font-size: 0.8rem;
  }
}
</style>